/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, NgZone, ViewContainerRef } from '@angular/core';

import { IFrameworkFactory } from 'ag-grid-community';

@Injectable()
export class GridFrameworkFactory implements IFrameworkFactory {
  private viewContainerRef: ViewContainerRef;

  constructor(private _ngZone: NgZone) {
  }

  setViewContainerRef(viewContainerRef: ViewContainerRef): void {
    this.viewContainerRef = viewContainerRef;
  }

  setTimeout(action: any, timeout?: any): void {
    this._ngZone.runOutsideAngular(() => {
      setTimeout(
        () => {
          this._ngZone.run(action);
        },
        timeout);
    });
  }
}
